import { useState, useEffect } from "react";
import axiosInstance from "../../src/common/axiosInstance"; // Adjust path based on your project structure
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import {
  apiError,
} from "../slices/Auth/Login/reducer";
import profile_placeholder from "../assets/images/users/profile_placeholder.jpg"
const useAgencyData = () => {
  const [agencyName, setAgencyName] = useState("");
  const [agencyLogo, setAgencyLogo] = useState("");
  const [agencyId, setAgencyId] = useState("");
  const [subdomainAgencyId, setSubdomainAgencyId] = useState("");
  const [domain, setAgencyDomain] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const getAgencyData = async () => {
      try {
        const url = window.location.href;
        let agency_id = '';
        let var_slug = '';
        
        // Only parse reset password parameters if we're on the reset-password page
        if(location.pathname.startsWith('/reset-password/')){
          // Get the token from the pathname
          const pathSegments = location.pathname.split('/');
          var_slug = pathSegments[pathSegments.length - 1];
          
          // Get agency_id from query parameters
          const urlParams = new URLSearchParams(location.search);
          agency_id = urlParams.get('agency_id') || '';
        }
        
        const host = window.location.hostname; // e.g., catalyst.uds.com
        const parts = host.split("."); // ['catalyst', 'uds', 'com']
        // parts[0] = 'catalyst';
        if (parts.length > 2) {
          setAgencyDomain(parts[0]); // 'catalyst'
        }
        const response = await axiosInstance.get(`/agency-data`, {
          params: { agency_subdomain: parts[0],agency_id : agency_id, var_slug : var_slug,location : location.pathname }, // Directly use `parts[0]`
        });

        if(response?.data?.data?.agency_data?.agency_id) {
          setSubdomainAgencyId(response.data.data.agency_data.agency_id);
        }
        if(response?.data?.data?.user_data) {
          const expireDate = new Date(response.data.data.user_data.expire_date);
          const today = new Date();
          if (expireDate < today && agency_id) {
              dispatch(apiError("Either the reset password link has expired or is invalid"));
              navigate('/login')
              return;
          }else if(expireDate < today){
            navigate('/forgot-password', { state: { message: "Either the forgot password link has expired or is invalid" } });
            return;
          }
        }else if(location.pathname.startsWith('/reset-password/') && response?.data?.data?.user_data == null && response?.data?.data?.agency_data == null){
          dispatch(apiError("Please check the link, it is invalid."));
          dispatch(apiError("The link is invalid or has expired. Please contact your administrator for a valid link."));
          navigate('/login')
          return;
        }

        if(location.pathname.startsWith('/reset-password/')){
          if(response?.data?.data?.agency_data) {
            if(!response?.data?.data?.user_data){
              dispatch(apiError("Either the set password link has expired or is invalid"));
              navigate('/login')
              return;
            }
            setAgencyId(response.data.data.agency_data.agency_id);
            setAgencyName(response.data.data.agency_data.agency_name);
            setAgencyLogo(response.data.data.agency_data.agency_logo);
            document.title = `Create Password | UDS`;
            setFavicon(response.data.data.agency_data.agency_logo);
          }else if(var_slug){
            setAgencyName(response.data.data.user_data.name);
            setAgencyLogo(response.data.data.user_data.profile_picture_url ? response.data.data.user_data.profile_picture_url : profile_placeholder);
            document.title = `Forgot Password | UDS`;
          }
        }else{
          setAgencyName(response.data.data.agency_data.agency_name);
          setAgencyLogo(response.data.data.agency_data.agency_logo);
          setFavicon(response.data.data.agency_data.agency_logo);
          document.title = `Login | UDS`;
        }
      } catch (error) {
        console.error("Error fetching agency data:", error);
      }
    };

    getAgencyData();
  }, []);

  const setFavicon = (url: string) => {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      link.type = "image/png"; // Specify image type
      document.head.appendChild(link);
    }
    link.href = url;
  };

  return { agencyName, agencyLogo, agencyId, domain, subdomainAgencyId };
};

export default useAgencyData;
